export { parse } from './parse';
export { getByPath } from './getByPath';
export { interpolate, type InterpolateOptions } from './interpolate';
export { interpolateObject } from './interpolateObject';
export { hasTemplate, hasTemplateDeep } from './hasTemplate';
export { extractPaths, extractRootNames } from './extractPaths';
export { InterpolationError } from './InterpolationError';
export {
  deriveAnchors,
  buildContextNamespace,
  type OrderedSequenceContext,
  type OrderedSequenceRegistry,
  type DerivedAnchors,
} from './context-anchors';
export type {
  Expression,
  InterpolationContext,
  Literal,
  PathSegment,
  Template,
} from './types';
